import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ad001c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "p-3 p-lg-4 shadow rounded-4 bg-white mb-4 mb-lg-5" }
const _hoisted_5 = {
  class: "fw-bold fs-5 mb-3 lh-base cursor-pointer",
  "data-bs-toggle": "modal",
  "data-bs-target": "#chatModal"
}
const _hoisted_6 = { class: "d-flex flex-column flex-lg-row justify-content-between user-title" }
const _hoisted_7 = { class: "mb-2 d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "fs-7 fw-bold"
}
const _hoisted_9 = {
  key: 1,
  class: "fw-bold fs-7"
}
const _hoisted_10 = {
  key: 0,
  class: "d-flex flex-column align-items-lg-center align-items-end"
}
const _hoisted_11 = {
  key: 0,
  class: "text-danger fs-8 fw-bold text-center mb-2"
}
const _hoisted_12 = {
  key: 1,
  class: "text-white bg-danger px-4 py-2 position-absolute position-drawn"
}
const _hoisted_13 = {
  key: 2,
  class: "text-white bg-danger px-4 py-2 position-absolute position-drawn"
}
const _hoisted_14 = {
  key: 3,
  class: "position-drawn text-white bg-black px-4 py-2 position-absolute"
}
const _hoisted_15 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "last-comment position-relative w-100" }, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "text-danger fs-8 fw-bold text-center mb-2 text-nowrap"
}
const _hoisted_18 = {
  key: 1,
  class: "d-flex justify-content-center list-chat"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "mb-2 d-flex justify-content-center" }

import { computed, ComputedRef, nextTick, onUnmounted, onMounted, ref, watch, watchEffect } from 'vue'
import Category from '@/components/category/index.vue'
import Button from '@/components/button/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import MessageItem from '../components/MessageItem.vue'
import MessageItemReadOnly from '../components/MessageItemReadOnly.vue'
import Avatar from '@/components/avatar'
import { translate } from '@/languages/i18n'
import ChatModal from '@/views/user/conversations/components/ChatModal.vue'
import DeleteChatModal from '@/views/user/conversations/components/DeleteChatModal.vue'
import DeleteChatSuccessModal from '@/views/user/conversations/components/DeleteChatSuccessModal.vue'
import dayjs from 'dayjs'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { ReplayName } from '@/constants/common.ts'

//constant
import { useStore } from 'vuex'
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { CHAT_STORE, POST_STORE, ROOT_STORE } from '@/store/constants'
import { PostType } from '@/store/modules/post'
import { Chat } from '@/store/modules/chat'

import { useWebSocket } from '@/use/useWebsocket'

import VirtualList from 'vue3-virtual-scroll-list'
import { useChat } from '@/composables/chat'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()
const virtual_list = ref()

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('userManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('chatManagement'),
    to: `/community/communities/${route.params?.id}/manage_chat_room`,
    active: false,
  },
  {
    content: translate('chat'),
    to: '',
    active: true,
  },
]
const { addReconnectListeners, removeReconnectListeners, getData } = useChat()

const { connection, reconnect } = useWebSocket('chatChannel', {
  onConnected: () => {
    // Only re-fetch data if the page has finished initializing its initial data
    // Ensure the API is re-fetched in both cases: remaining on the tab and background reconnection
    if (getData.value) {
      fetchChatRoomData()
    }
  },
})

const post = computed<ComputedRef<PostType>>(() => store.getters[POST_STORE.GETTERS.POST])
const page = computed(() => store.getters[CHAT_STORE.GETTERS.PAGE_CHAT])
const loadingChat = computed(() => store.getters[CHAT_STORE.GETTERS.LOADING_CHAT])

const chats = computed<ComputedRef<Array<Chat>>>(() => store.getters[CHAT_STORE.GETTERS.CHAT_ROOM])
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const message = computed(() => store.getters[CHAT_STORE.GETTERS.GET_MESSAGE_SOCKET])
// const currentLoggedInUser = computed<ComputedRef<number>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME]?.community_management_id)

const back = (): void => {
  router.go(-1)
}

const loading = ref<boolean>(false)

onMounted(async () => {
  addReconnectListeners(connection, reconnect)
  if (route.params?.post_id) {
    loading.value = true
    await store.dispatch(POST_STORE.ACTIONS.GET_CHAT_ROOM_USERS, {
      ...route.params,
      user_type: route.params?.management_no.slice(0, 1) === 'A' ? 'alumnus' : 'users',
      create_by_admin: true,
    })
    await fetchChatRoomData()
    getData.value = true
    setTimeout(() => {
      loading.value = false
    }, 500)
  }
})

watch(
  () => chats,
  () => {
    if (message.value?.chatroom_id === route.params?.chatroom_id) {
      if (message.value?.type === 'create') {
        store.dispatch(CHAT_STORE.ACTIONS.RECEIVE_MESSAGE, message.value)
      }
      if (message.value?.type === 'delete') {
        store.dispatch(CHAT_STORE.ACTIONS.REMOVE_MESSAGE_WS, message.value.id)
      }
    }
  },
  {
    deep: true,
  }
)

watch(
  () => chats,
  async () => {
    await nextTick()
    if (page.value === 1) {
      // not use function scrollToBottom from virtual_list may cause infinite loop
      // await virtual_list.value?.scrollToBottom()
      virtual_list.value.scrollTop = 9999999999
      const scroller = document.querySelector('.scroller')
      scroller.scrollTop = 9999999999
    } else {
      virtual_list.value.scrollTop = 8000
      const scroller = document.querySelector('.scroller')
      scroller.scrollTop = 8000
    }
  },
  {
    deep: true,
  }
)

watchEffect(() => {
  if (getData.value && !post.value?.chatroom?.id && !chats.value?.length) {
    router.go(-2)
  }
})

const dataLoadMore = ref()

watchEffect(() => {
  dataLoadMore.value = [...chats.value]
  dataLoadMore.value.unshift({ id: 'first_chat_page' })
})

onMounted(() => {
  virtual_list.value = document.querySelector('.scroller')
  store.dispatch(CHAT_STORE.ACTIONS.SET_PAGE_CHAT, 1)
})

onBeforeRouteLeave(() => {
  getData.value = false
  store.dispatch(CHAT_STORE.ACTIONS.SET_PAGE_CHAT, 1)
})

const fetchChatRoomData = async () => {
  await store.dispatch(CHAT_STORE.ACTIONS.GET_CHAT_ROOM, {
    chatroom_id: route.params?.chatroom_id,
    params: {
      create_by_admin: true,
      page: 1,
      change: true,
    },
  })
}

onUnmounted(() => {
  removeReconnectListeners()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([loading.value && 'hidden-layout'])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(['detail-header position-relative', _unref(isMobile) ? '' : 'border-bottom mb-4 pb-4 '])
        }, [
          _createVNode(Category, {
            content_type: _unref(post)?.content_type
          }, null, 8, ["content_type"]),
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(post)?.title), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(Avatar), {
                is_deleted_in_30_days: _unref(post)?.user_post?.is_deleted_in_30_days,
                user_image_url: _unref(post)?.user_post?.avatar_url,
                size: 'small',
                userType: _unref(post)?.user_post?.user_type
              }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"]),
              _createVNode(UserAliasIcon, {
                userType: _unref(post)?.user_post?.user_type
              }, null, 8, ["userType"]),
              (_unref(post)?.user_post?.user_type !== 'community_admin')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(post)?.user_post?.management_no +
                ' ' +
                _unref(ReplayName)(
                  _unref(post)?.user_post?.is_deleted_in_30_days,
                  _unref(post)?.user_post?.available,
                  _unref(post)?.user_post?.family_name,
                  _unref(post)?.user_post?.given_name,
                  _unref(post)?.user_post?.user_type
                )) + " " + _toDisplayString(_unref(post)?.user_post?.user_type == 'alumni' && [0, 1].includes(_unref(post)?.user_post?.is_deleted_in_30_days) ? `（ ${_unref(post)?.user_post?.display_name} ）` : ''), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(post)?.user_post?.display_name), 1))
            ]),
            (!_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (
                !_unref(post)?.chatroom?.closed &&
                ![
                  `/community/communities/${_unref(route).params?.id}/alumnus/${_unref(route).params?.management_no}/posts/${_unref(route).params?.post_id}/chats/${_unref(route).params?.chatroom_id}`,
                  `/community/communities/${_unref(route).params?.id}/community-users/${_unref(route).params?.management_no}/posts/${_unref(route).params?.post_id}/chats/${_unref(route).params?.chatroom_id}`,
                ].includes(_unref(route).path)
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(dayjs)(_unref(post)?.chatroom.end_date, 'YYYY-MM-DD').format('MM/DD')) + "まで会話できます", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_unref(post)?.chatroom.is_deleted_in_30_days !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(translate)('SM10withdrawn')), 1))
              : (!_unref(post)?.chatroom.available)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(translate)('SM10stopped')), 1))
                : _createCommentVNode("", true),
            (
              (_unref(post)?.chatroom.closed || (!_unref(post)?.chatroom.closed && !_unref(dayjs)().isBefore(_unref(dayjs)(_unref(post)?.chatroom?.end_date).add(1, 'day')))) &&
              _unref(post)?.chatroom.is_deleted_in_30_days === 0 &&
              _unref(post)?.chatroom.available
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(translate)('end')), 1))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              (
            !_unref(post)?.chatroom?.closed &&
            ![
              `/community/communities/${_unref(route).params?.id}/alumnus/${_unref(route).params?.management_no}/posts/${_unref(route).params?.post_id}/chats/${_unref(route).params?.chatroom_id}`,
              `/community/communities/${_unref(route).params?.id}/community-users/${_unref(route).params?.management_no}/posts/${_unref(route).params?.post_id}/chats/${_unref(route).params?.chatroom_id}`,
            ].includes(_unref(route).path)
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(dayjs)(_unref(post)?.chatroom.end_date, 'YYYY-MM-DD').format('MM/DD')) + "まで会話できます", 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_unref(loadingChat))
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
          : _createCommentVNode("", true),
        (
          ![
            `/community/communities/${_unref(route).params?.id}/alumnus/${_unref(route).params?.management_no}/posts/${_unref(route).params?.post_id}/chats/${_unref(route).params?.chatroom_id}`,
            `/community/communities/${_unref(route).params?.id}/community-users/${_unref(route).params?.management_no}/posts/${_unref(route).params?.post_id}/chats/${_unref(route).params?.chatroom_id}`,
          ].includes(_unref(route).path)
        )
          ? (_openBlock(), _createBlock(_unref(VirtualList), {
              key: 2,
              class: "scroller",
              ref: (_value, _refs) => {
                _refs['virtual_list'] = _value
                virtual_list.value = _value
              },
              style: {"height":"540px","overflow-y":"auto","overflow-x":"hidden"},
              "estimate-size": 80,
              keeps: 1000,
              "data-key": 'id',
              "data-sources": dataLoadMore.value,
              "data-component": MessageItem,
              "extra-props": { is_admin: true }
            }, null, 8, ["data-sources"]))
          : (_openBlock(), _createBlock(_unref(VirtualList), {
              key: 3,
              class: "scroller",
              ref: (_value, _refs) => {
                _refs['virtual_list'] = _value
                virtual_list.value = _value
              },
              style: {"height":"540px","overflow-y":"auto","overflow-x":"hidden"},
              "estimate-size": 80,
              keeps: 1000,
              "data-key": 'id',
              "data-sources": dataLoadMore.value,
              "data-component": MessageItemReadOnly,
              "extra-props": { is_admin: true }
            }, null, 8, ["data-sources"]))
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(Button, {
          title: _unref(translate)('back'),
          type: 'secondary',
          className: "mb-0 mb-lg-3 fw-bold",
          onClick: back
        }, null, 8, ["title"])
      ]),
      _createVNode(ChatModal, { create_by_admin: true }),
      _createVNode(DeleteChatModal),
      _createVNode(DeleteChatSuccessModal)
    ], 2)
  ], 64))
}
}

})